import {Reducer} from 'redux'
import {CategoriesActionTypes, CategoriesState} from './types';
import CategoriesService from "../../services/CategoriesService";

// Type-safe initialState!
const initialState: CategoriesState = {
	list: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<CategoriesState> = (state = initialState, action) => {
	switch (action.type) {
		case CategoriesActionTypes.FETCH_ALL_REQUEST: {
			CategoriesService.getAll()
			return { ...state, loading: true }
		}
		case CategoriesActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case CategoriesActionTypes.FETCH_ONE_REQUEST: {
			CategoriesService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case CategoriesActionTypes.FETCH_ONE_COMPLETED: {
			// updates list but I do not see usage of this at the moment
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case CategoriesActionTypes.SAVE_REQUEST: {
			CategoriesService.save(action.payload)
			return { ...state, loading: true }
		}
		case CategoriesActionTypes.SAVE_COMPLETED: {
			console.log(action.payload)
			return { ...state, loading: false}
		}
		case CategoriesActionTypes.DELETE_REQUEST: {
			CategoriesService.delete(action.payload)
			return { ...state, loading: true }
		}
		case CategoriesActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case CategoriesActionTypes.DELETE_MULTIPLE_REQUEST: {
			CategoriesService.deleteMultiple(action.payload)
			return { ...state, loading: true }
		}
		case CategoriesActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export { reducer as CategoriesReducer }
